"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBanksForContext = exports.ACCOUNT_TYPES = exports.BANKS = void 0;
exports.BANKS = [
    { label: "FNB Botswana", value: "FNB Botswana" },
    { label: "Standard Chartered Botswana", value: "Standard Chartered Botswana" },
    { label: "Stanbic Bank Botswana", value: "Stanbic Bank Botswana" },
    { label: "Absa Bank Botswana", value: "Absa Bank Botswana" },
    { label: "Bank Gaborone", value: "Bank Gaborone" },
    { label: "Bank of Baroda Botswana", value: "Bank of Baroda Botswana" },
    { label: "Access Bank Botswana", value: "Access Bank Botswana" },
    { label: "BBS Bank", value: "BBS Bank" },
];
exports.ACCOUNT_TYPES = [
    { label: "Cheque", value: "Cheque" },
    { label: "Savings", value: "Savings" },
];
var getBanksForContext = function (context) {
    return exports.BANKS; // All banks available for all contexts
};
exports.getBanksForContext = getBanksForContext;
